const templateUrl = require('./shipment-upsell.html');

const app = angular.module('msi.upsell.ogShipmentUpsell', []);

app.component('ogShipmentUpsell', {
  templateUrl: templateUrl,
  controller: ['config', function(merchSettings) {
    this.landingPage = merchSettings.landingPageUrl;
  }]
});

module.exports = app.name;
